import { Suggestion } from 'api/clients/SuggestionsClient'

export enum Actions {
  UPSERT_SUGGESTIONS = 'UPSERT_SUGGESTIONS',
  UPSERT_SUGGESTION = 'UPSERT_SUGGESTION',
}

export function upsertSuggestions(suggestions: Suggestion[]) {
  return {
    type: Actions.UPSERT_SUGGESTIONS,
    payload: { suggestions },
  }
}

export function upsertSuggestion(suggestion: Suggestion) {
  return {
    type: Actions.UPSERT_SUGGESTION,
    payload: { suggestion },
  }
}
